import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: auto;
  padding-bottom: 1rem;
  background: ${({ theme }) => theme.colors.white};
  padding: 0 1.5rem;
  margin: 0.5rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 1.5rem;
  }
`;

export const SearchAndActionsBlock = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  & > button {
    margin-left: 1rem;
    margin-bottom: 0.15rem;
    width: 20%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: unset;
  }
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  & > header {
    width: 4.125rem;
    height: 2rem;
    left: 1.5rem;
    top: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.grayDark3};

    margin-top: 0.5rem;
    margin-bottom: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-bottom: unset;
    }
  }
`;
